import { render, staticRenderFns } from "./Selective.vue?vue&type=template&id=d5d0f12e&scoped=true&"
import script from "./Selective.vue?vue&type=script&lang=js&"
export * from "./Selective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d0f12e",
  null
  
)

export default component.exports